// extracted by mini-css-extract-plugin
module.exports = {"animated":"e_ud","dots":"e_vd"};